import { CarrierDynamicControls, ICarrierDynamicControlsParameters } from '../form-controls/carrier.form-controls';
import { ICarrier } from '../interfaces/carrier';
import { DynamicField, DynamicFieldType, DynamicFieldTypes, DynamicLabel, NumericInputTypes } from '@mt-ng2/dynamic-form';

export class CarrierDynamicControlsPartial extends CarrierDynamicControls {

    constructor(carrierPartial?: ICarrier, additionalParameters?: ICarrierDynamicControlsParameters) {
        super(carrierPartial, additionalParameters);

        // Override the CreditLimit field to use currency formatting
        this.Form.CreditLimit = new DynamicField({
            formGroup: this.formGroup,
            label: 'Credit Limit (in USD)',
            name: 'CreditLimit',
            options: null,
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Numeric,
                inputType: NumericInputTypes.Currency,
                scale: 2,
            }),
            validation: [],
            validators: {},
            value: carrierPartial && carrierPartial.hasOwnProperty('CreditLimit') && carrierPartial.CreditLimit != null ? carrierPartial.CreditLimit : 0,
        });

        this.View.CreditLimit = new DynamicLabel({
            label: 'Credit Limit (in USD)',
            value: carrierPartial && carrierPartial.hasOwnProperty('CreditLimit') && carrierPartial.CreditLimit != null ? carrierPartial.CreditLimit : 0,
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Numeric,
                inputType: NumericInputTypes.Currency,
                scale: 2,
            }),
        });
    }
}
